module.exports = __webpack_public_path__ + "static/media/Survivor Bias.05c216dc.jpg";